import {createAction} from '@reduxjs/toolkit';
import {
  SET_PENDING_BUSINESSES,
  SET_REJECTED_BUSINESSES,
  SET_BUSINESS_PAGINATION,
  SET_REJECTED_PAGINATION,
  SET_ALL_BUSINESSES,
  SET_ALL_BUSINESSES_PAGINATION,
} from '@crema/types/actions/Business.action';

export const SetPendingBusinesses = createAction<any[]>(SET_PENDING_BUSINESSES);
export const SetRejectedBusinesses = createAction<any[]>(
  SET_REJECTED_BUSINESSES,
);
export const SetBusinessPagination = createAction<{
  count: number;
  pages: number;
}>(SET_BUSINESS_PAGINATION);
export const SetRejectedPagination = createAction<{
  count: number;
  pages: number;
}>(SET_REJECTED_PAGINATION);
export const SetAllBusinesses = createAction<any[]>(SET_ALL_BUSINESSES);
export const SetAllBusinessesPagination = createAction<{
  count: number;
  pages: number;
}>(SET_ALL_BUSINESSES_PAGINATION);
